

export async function logout() {
  await window.auth.logout();
  window.location.reload();
}